import React, { useState } from "react";
import { ProductImage } from "../ProductImage/ProductImage";

const hasImageURL = (imageURL) => Boolean(imageURL) && imageURL !== "<nil>";

export default function ProductModal ({ imageURL }) {
	const [isModalVisible, setIsModalVisible] = useState(false);

	if (!hasImageURL(imageURL)) {
		return null;
	}

	return (
		<ProductImage
			buttonType={"icon"}
			onClick={() => setIsModalVisible(true)}
			isVisible={isModalVisible}
			onClose={() => setIsModalVisible(false)}
			imageURL={imageURL}
		/>
	);
}
